import React, { Fragment } from 'react';
import ReactTable from 'react-table';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TaxTableColumns from './TaxTableColumns';

const additionalChargesTooltipTextLine1 = 'Taxes are applied on an item level.';
const additionalChargesTooltipTextLine2 = 'Depending on your Local, State, Federal, and Country Tax Laws, you may need to include Tax on your outgoing invoices.';

const AdditionalCharges = ({
  groupSettings,
  handleDeleteCharge,
  toggleChargeModal
}) => {
  if (!groupSettings) {
    return null;
  }

  const { taxSettings } = groupSettings;
  const showTable = taxSettings.length > 0;

  return (
    <Fragment>
      <h3 className="mt-5 mb-3">
        Additional Charges | Taxes &amp; Fees&nbsp;
        <FontAwesomeIcon
          id="additionalChargesIcon"
          className="color-blue"
          icon="question-circle"
        />
        <UncontrolledTooltip placement="right" target="additionalChargesIcon">
          {additionalChargesTooltipTextLine1}
          <br />
          <br />
          {additionalChargesTooltipTextLine2}
        </UncontrolledTooltip>
      </h3>
      {showTable && (
        <ReactTable
          className="-highlight"
          minRows={1}
          data={taxSettings}
          defaultPageSize={500}
          columns={TaxTableColumns(handleDeleteCharge, toggleChargeModal)}
          showPagination={false}
          style={{ width: '100%' }}
        />
      )}

      <Button color="link" role="link" onClick={() => toggleChargeModal()}>
        <FontAwesomeIcon icon="plus" />
        &nbsp;Add Charge Type
      </Button>
    </Fragment>
  );
};

export default AdditionalCharges;
